export default "__VITE_ASSET__9u21aOXA__"